import { Favorite, FavoriteBorder } from '@mui/icons-material';
import { type Theme, Typography, styled, useTheme } from '@mui/material';
import { red } from '@mui/material/colors';
import { type SystemStyleObject } from '@mui/system';
import { type ScreenType } from '@tmdb-graphql-api/schema/types';
import { isEqual } from 'lodash-es';
import { useStore } from '#store/useStore.ts';

const Container = styled('span')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
}));

export type FavoriteBadgeProps = {
  compact?: boolean;
  id: string;
  sx?: SystemStyleObject<Theme>;
  type: ScreenType;
};

export const FavoriteBadge = ({ compact, id, sx, type }: FavoriteBadgeProps) => {
  const theme = useTheme();
  const addFavorite = useStore(store => store.addFavorite);
  const favorites = useStore(store => store.favorites);
  const removeFavorite = useStore(store => store.removeFavorite);
  const hasFavorite = favorites.some(entry => isEqual(entry, { id, type }));
  const Icon = hasFavorite ? Favorite : FavoriteBorder;

  const handleClick = () => {
    if (hasFavorite) {
      removeFavorite({ id, type });
    } else {
      addFavorite({ id, type });
    }
  };

  return (
    <Container
      onClick={handleClick}
      sx={{
        ...sx,
        justifyContent: compact ? 'center' : undefined,
      }}
    >
      {compact ? undefined : (
        <Typography
          sx={{
            [theme.breakpoints.down('sm')]: {
              display: 'none',
            },
            color: theme.supportingTextPrimary,
            fontSize: '0.75rem',
            marginBottom: theme.spacing(0.2),
            textAlign: 'center',
          }}
        >
          FAVORITE
        </Typography>
      )}
      <Icon
        sx={{
          color: red[500],
          fontSize: '2.3rem',
        }}
      />
    </Container>
  );
};
